<template>
    <div class="w-full flex h-screen">
        <textarea
            name="text"
            @input="render"
            v-model="input"
            placeholder="Write something..."
            class="w-1/2 border-r h-screen p-8 font-mono text-sm"
        ></textarea>
        <div class="w-1/2 h-screen p-8 bg-grey-100 overflow-y-scroll">
            <div class="w-full max-w-sm flex">
                <div class="pr-2">
                    <div class="bg-grey rounded-full w-8 h-8"></div>
                </div>
                <div class="flex-1">
                    <div
                        v-html="rendered"
                        class="markdown-area bg-grey-200 border border-grey-400 rounded p-4 text-sm"
                    ></div>
                    <div class="text-right text-xs">
                        Sent by APIRO a moment ago
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data: function () {
        return {
            input: '',
            rendered: '',
        };
    },

    methods: {
        render: _.debounce(function (event) {
            window.axios
                .post('/markdown', {
                    text: this.input,
                })
                .then(response => {
                    this.rendered = response.data;
                });
        }, 150),
    },
}
</script>
